export default __webpack_public_path__ + "static/img_1_0-87d9b902f66debed22dabe1c574fff8a.webp";